import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { MockComponent } from '@kutil/test';

const LOOP_ANIMATION_DURATION = 1850; // 1:51s

@Component({
  selector: 'kp-reflect-animation',
  templateUrl: './reflect-animation.component.html',
  styleUrls: ['./reflect-animation.component.scss'],
})
export class ReflectAnimationComponent implements OnInit {
  @Input() skipIntro = false;
  // CSS is set up so the canvas will fill out the width of its containing div.
  // Animation looks the crispest when the canvas resolution matches the canvas size.
  @Input() canvasHeight = 192;
  @Input() canvasWidth = 192;
  @Output() introOver: EventEmitter<boolean> = new EventEmitter();

  playIntro = false;
  playLoop = false;

  @HostBinding('class.use-alternate')
  useAlternate = false;

  ngOnInit() {
    // use generic alternate if no WASM support
    this.useAlternate = typeof WebAssembly !== 'object';

    // setup intro / loop
    this.playIntro = !this.skipIntro && !this.useAlternate;
    this.playLoop = this.skipIntro || this.useAlternate;

    if (this.useAlternate) {
      this.introOver.emit();
    }
  }

  loaded() {
    if (this.playIntro) {
      // swap to loop once intro is done
      setTimeout(() => {
        this.playIntro = false;
        this.playLoop = true;
        this.introOver.emit();
      }, LOOP_ANIMATION_DURATION);
    }
  }
}

export const MockReflectAnimationComponent = MockComponent({
  selector: 'kp-reflect-animation',
  inputs: ['canvasHeight', 'canvasWidth', 'skipIntro'],
});
